import React, { useRef, useEffect, useState } from "react";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";

export default function FiltroPinesMaestros({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {

    const adaptNombre = (e) =>  e ? { ...e, label: e.nombre } : null;

  const filtroRef = useRef(null);

    // ============================
    //        ESTADOS (rehidratables)
    // ============================

    const [estacion, setEstacion] = useState(
        adaptNombre(initialFilters.eess) ?? null
    );


  const [nroPin, setNroPin] = useState(
    initialFilters.numero ?? ""
  );

  const [estadoId, setEstadoId] = useState(
    initialFilters.estadoId ?? ""
  );

  // ============================
  //   CERRAR CLICK FUERA / ESC
  // ============================
  useEffect(() => {
    const outside = (event) => {
      if (filtroRef.current && !filtroRef.current.contains(event.target)) {
        onClose();
      }
    };

    const esc = (event) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // ============================
  //        SUBMIT
  // ============================
  const handleSubmit = (event) => {
    event.preventDefault();

    onSubmit({
        numero: nroPin ? Number(nroPin) : null,
        // 🔥 objeto completo del autocomplete
        eess: estacion,
        // 🔥 solo lo que va al backend
        eessId: estacion?.id ?? null,
        estadoId: estadoId || null,
    });

  };

  // ============================
  //        RENDER
  // ============================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          {/* Nro de PIN */}
          <div>
            <label className="form-label-fil">Nro de PIN</label>
            <input
              type="text"
              className="input"
              value={nroPin}
              onChange={(e) => setNroPin(e.target.value)}
            />
          </div>

          {/* EESS */}
          <div>
            <label className="form-label-fil">EE..SS.</label>
            <EessAutocomplete
                value={estacion}
                onChange={(e) => setEstacion(adaptNombre(e))}
                placeholder="Buscar EE.SS..."
            />
          </div>

          {/* Estado */}
          <div>
            <label className="form-label-fil">Estado</label>
            <select
              className="input"
              value={estadoId}
              onChange={(e) => setEstadoId(e.target.value)}
            >
              <option value="">-- Todos --</option>
              <option value="14">PIN ACTIVO</option>
              <option value="15">PIN INACTIVO</option>
            </select>
          </div>

          <div className="text-right">
            <button type="submit" className="btn">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
